module.exports = __webpack_public_path__ + "static/media/29BDOS11.bfd03edb.jpg";